import { useState } from "react";
import CreateIssue from "../CreateIssue/CreateIssue";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import { useTranslation } from "@i18n";
import Text from "@CubeComponents/html/Text/Text";
import SelectSpaces from "@Components/WorkspaceList/SelectSpaces";
import type { Space } from "@Components/WorkspaceList/useSelectSpaces";
import { defaultModulesMapper } from "@Helpers/constants";

interface CreateIssueModalProps {
  extraParametersOnIssueCreation?: Record<string, unknown>;
  closeModal: () => void;
  refreshDataGrid?: () => void;
  projectId: string;
  attachedReviewId?: string | null;
  defaultSpaceId?: string | null;
  isEditMode?: boolean;
}

function CreateIssueModal({
  extraParametersOnIssueCreation = {},
  closeModal,
  refreshDataGrid,
  projectId,
  attachedReviewId,
  defaultSpaceId = null,
  isEditMode = false,
}: Readonly<CreateIssueModalProps>) {
  const { t } = useTranslation();
  const [spaceId, setSpaceId] = useState(defaultSpaceId);
  const getSpacesDropdown = () => (
    <div className="w-56">
      <SelectSpaces
        moduleName={defaultModulesMapper.ISSUES}
        dataTestId="spaceDropdownField"
        allowBorder={true}
        projectId={projectId}
        workspaceId={spaceId ?? undefined}
        isDisabled={isEditMode}
        selectedSpaceCallback={(space: Space) => {
          setSpaceId(space._id);
        }}
      />
    </div>
  );

  const headerContent = () => (
    <div className="w-full flex justify-between rounded-md items-center ps-6 py-4 gap-4">
      <Text>{isEditMode ? t("Edit Issue") : t("Create Issue")}</Text>
      {getSpacesDropdown()}
    </div>
  );

  const modelContent = () => (
    <div className="h-[50rem]">
      <CreateIssue
        extraParametersOnIssueCreation={extraParametersOnIssueCreation}
        isOutsideViewer
        isEditMode={isEditMode}
        onCancel={closeModal}
        workspaceId={spaceId}
        refreshDataGrid={refreshDataGrid}
        attachedReviewId={attachedReviewId}
      />
    </div>
  );

  return (
    <ModalStateDialogComponent
      isVisible
      onCancel={closeModal}
      allowModalPadding={false}
      width="70%"
      headerTitle={headerContent()}
      modelContent={modelContent()}
      modalPadding={0}
    />
  );
}

export default CreateIssueModal;
